export enum TransactionStatuses {
  PENDING = 'pending',
  CONFIRMED = 'completed',
  FAILED = 'declined'
}

export enum CreamTransactionTypes {
  BUY = 'buy',
  SELL = 'sell'
}
